import type { ComponentProps } from 'react';

export const CheckboxCheckedIcon = (props: ComponentProps<'svg'>) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_467_6248)">
      <rect width="80" height="80" rx="13.2973" fill="#81C73D" />
      <path d="M20 41.7L28.3909 54.2445L30.2341 57L31.8322 54.2445C39.8606 40 47.8132 23 59 23" stroke="white"
            strokeWidth="6" strokeLinecap="round" strokeLinejoin="bevel" />
    </g>
    <rect x="1.66216" y="1.66216" width="76.6757" height="76.6757" rx="11.6351" stroke="#81C73D"
          strokeWidth="3.32433" />
    <defs>
      <clipPath id="clip0_467_6248">
        <rect width="80" height="80" rx="13.2973" fill="white" />
      </clipPath>
    </defs>
  </svg>

);